module.exports = __webpack_public_path__ + "media/images/pharamaday-template-63fdd0ea2697297171447b0df0632af4.jpg";